import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';

interface IReduxSavedConfigs {
  currentKey: string;
  currentValue: IReduxSavedConfig | null;
  configStatus: {
    [key: string]: boolean | undefined;
  };
}

interface IReduxSavedConfig {
  accessories: string[];
  dealerId: string;
  drivetrain: string;
  engine: string;
  extAccessories: string[];
  exterior: string;
  intAccessories: string[];
  interior: string;
  modelId: string;
  modelSeries: string;
  modelYear: string;
  package: string;
  tab: string;
  timestamp: number;
  totalPrice: number;
  transmission: string;
}

const initialState: IReduxSavedConfigs = {
  currentKey: '',
  currentValue: null,
  configStatus: {},
};

export const savedConfig = createSlice({
  name: 'savedConfig',
  initialState,
  reducers: {
    setCurrentConfig: (state, action: PayloadAction<string>) => {
      const key = action.payload;
      const value = localStorage.getItem(key);
      state.currentKey = key;
      state.currentValue = value ? JSON.parse(value) : value;
    },
    setCurrentConfigBap: (
      state,
      action: PayloadAction<{ key: string; hideStartOverDisplay: boolean }>
    ) => {
      const { key, hideStartOverDisplay } = action.payload;
      const value = localStorage.getItem(key);
      state.currentKey = key;
      state.currentValue = value ? JSON.parse(value) : value;
      if (hideStartOverDisplay) {
        state.configStatus[key] = true;
      } else {
        state.configStatus[key] = value ? state.configStatus[key] : true;
      }
    },
    setLatestConfig: (
      state,
      action: PayloadAction<{ modelName: string; modelYears: string[] }>
    ) => {
      const { modelName, modelYears } = action.payload;
      let moreRecentConfig: IReduxSavedConfig | null = null;
      let moreRecentKey = '';

      modelYears.forEach((year) => {
        const key = `${modelName.toLowerCase()}-${year}`;
        const reviewedConfig = localStorage.getItem(key);
        const parsedConfig = reviewedConfig ? JSON.parse(reviewedConfig) : null;

        if (!moreRecentConfig) {
          moreRecentConfig = parsedConfig;
          moreRecentKey = parsedConfig ? key : '';
        } else if (
          parsedConfig &&
          parsedConfig.timestamp > moreRecentConfig.timestamp
        ) {
          moreRecentConfig = parsedConfig;
          moreRecentKey = key;
        }
      });
      state.currentKey = moreRecentKey;
      state.currentValue = moreRecentConfig;
    },
    setConfigStatus: (state, action: PayloadAction<boolean>) => {
      state.configStatus[state.currentKey] = action.payload;
    },
  },
});

export const {
  setCurrentConfig,
  setCurrentConfigBap,
  setLatestConfig,
  setConfigStatus,
} = savedConfig.actions;

export const getCurrentConfig = (state: RootState) => ({
  ...state.savedConfig,
  configStatus: state.savedConfig.configStatus[state.savedConfig.currentKey],
});

export const getPageLoadSavedConfig = (state: RootState) => {
  const {
    modelSeries,
    modelYear,
    modelId,
    package: packageName,
    exterior,
    interior,
    engine,
    drivetrain,
    accessories,
    extAccessories,
    intAccessories,
  } = state.savedConfig.currentValue || {};
  let pageLoadObj = {
    modelSeries: modelSeries || '',
    modelYear: modelYear || '',
    modelId: modelId || '',
    modelTrim: packageName || '',
    accessories: accessories || [],
    buildAndPrice: {
      exteriorColor: exterior || '',
      interiorColor: interior || '',
      powertrain: engine || '',
      drivetrain: drivetrain || '',
      interiorAccessories: intAccessories || [],
      exteriorAccessories: extAccessories || [],
    },
  };
  return pageLoadObj;
};

export default savedConfig.reducer;
